import type { Beneficiaire } from '../services/api';

/**
 * Colonnes du format AGICAP (ordre canonique) — utilisées pour le modèle
 * d'import, l'export CSV et le modèle .xlsx. Les noms d'en-tête correspondent
 * à ce que reconnaît l'import (cf. server/routes/beneficiaires.ts col()).
 */
export const AGICAP_HEADERS = [
  'Name',
  'Account number',
  'Local clearing code',
  'Bank country',
  'Bank name',
  'Bank identifier',
  'Intermediary bank identifier',
  'Number',
  'Street name',
  'Zip code',
  'City',
  'State/province/area',
  'Country',
] as const;

/** Un bénéficiaire → ligne (tableau de valeurs) dans l'ordre AGICAP. */
export function beneficiaireToRow(b: Beneficiaire): string[] {
  return [
    b.vendor_name ?? '',
    b.iban ?? '',
    b.clearing_code ?? '',
    b.bank_country ?? '',
    b.bank_name ?? '',
    b.bic ?? '',
    b.intermediary_bic ?? '',
    '', // Number : on stocke l'adresse complète dans Street name
    b.adresse_rue ?? '',
    b.adresse_cp ?? '',
    b.adresse_ville ?? '',
    b.adresse_etat ?? '',
    b.adresse_pays ?? '',
  ];
}

/**
 * Exemples de lignes pour le modèle (guident la saisie).
 *
 * FABRIQUÉS, et ils doivent le rester : ce fichier part dans le bundle, donc
 * dans le navigateur de chaque utilisateur. Il a porté jusqu'au 29/09/2026 deux
 * vrais bénéficiaires, avec IBAN complet, BIC et adresse postale.
 *
 * L'IBAN est celui que la documentation bancaire française utilise partout comme
 * exemple : sa clé est juste, donc la ligne franchit la validation et montre le
 * bon format, mais il ne désigne aucun compte.
 */
export const TEMPLATE_EXAMPLE_ROWS: string[][] = [
  ['EXEMPLE Camille', 'FR7630006000011234567890189', '', 'FR', '', '', '', '', '', '', '', '', ''],
  ['EI - EXEMPLE Dominique', 'FR7630006000011234567890189', '', 'FR', '', 'QNTOFRP1XXX', '', '12', 'rue de l’Exemple', '21000', 'DIJON', '', 'FR'],
];

function csvEscape(v: string): string {
  return /[",\n;]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v;
}

/** Construit le CSV (en-tête AGICAP + lignes) des bénéficiaires. */
export function buildBeneficiairesCsv(rows: Beneficiaire[]): string {
  const header = AGICAP_HEADERS.join(',');
  const lines = rows.map((b) => beneficiaireToRow(b).map(csvEscape).join(','));
  return [header, ...lines].join('\n');
}
